import { ActionIcon } from "@mantine/core";
import { IconTrash } from "@tabler/icons-react";
import React from "react";

const DeleteButton: React.FC<{ onClick: () => void; outline?: boolean }> = ({ onClick, outline = false }) => {
  return (
    <ActionIcon variant={outline ? "outline" : "filled"} color="red" size="sm" aria-label="Slett fil" onClick={onClick}>
      <IconTrash size={18} />
    </ActionIcon>
  );
};

export default DeleteButton;
